<template>
  <b-col
    cols="6"
    md="6"
  >
    <b-form-input
      v-if="!dataLoad && viewSearchInput"
      v-model="localSearchQuery"
      class="d-inline-block"
      placeholder="Search..."
      @keyup.enter="searchTable"
    />

  </b-col>
</template>

<script>
export default {
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    viewSearchInput: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
  data() {
    return {
      localSearchQuery: this.$route.query.search || '',
    }
  },
  mounted() {
    this.getRouting()
  },
  methods: {
    getRouting() {
      if (this.$route.query.search) {
        this.localSearchQuery = this.$route.query.search
        this.searchTable()
      }
    },
    searchTable() {
      if (this.localSearchQuery === '') {
        const updatedQuery = { ...this.$route.query }
        delete updatedQuery.search

        if (
          JSON.stringify(updatedQuery) !== JSON.stringify(this.$route.query)
        ) {
          this.$router.push({ query: updatedQuery })
        }
        this.getAllData(1)
      } else if (this.$route.query.search !== this.localSearchQuery) {
        this.$router.push({
          query: { ...this.$route.query, search: this.localSearchQuery },
        })
        this.getAllData(1)
      }
    },
  },
}

</script>
